import React from 'react';

import { RegistryList } from './styles';

export default function PaginationSize({
  offset, length, full, name,
}) {
  return (
    <RegistryList>
      {`Exibindo ${offset + 1} a ${
        offset + length > full ? full : offset + length
      } - Total de ${full} ${name}`}
    </RegistryList>
  );
}
